import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/uroweb/uroweb-frontend/layouts/default.vue").then(m => m.default || m)),
  module: defineAsyncComponent(() => import("/builds/uroweb/uroweb-frontend/layouts/module.vue").then(m => m.default || m))
}